import { create } from 'zustand';

/**
 * 이력 패널 진입을 모티프-정규 footer band로 이전하기 위한 경량 채널.
 *
 * footer band("지난 일지 보기" 링크, `TodaySealedFooterConnected` — shell의
 * windowContent 바깥)와 이력 패널 소유자(`TodayPage` — windowContent 안)는 분리된
 * 형제 서브트리라 직접 통신할 수 없다. 이 store가 그 사이를 잇는다 — footer는
 * "열어줘" 신호만 보내고, 패널 렌더·포커스·ESC 닫기는 여전히 `TodayPage`가 소유한다.
 *
 * 패턴 선례: `useTodayCloseStore`(같은 폴더, 마감 CTA를 footer band로 승격한 채널).
 */
interface TodayHistoryState {
  /** 이력 패널 열림 여부. footer 링크 → requestOpen, 패널 닫기/ESC → requestClose. */
  open: boolean;
  /** footer "지난 일지 보기" 클릭 → 패널 열기 요청. */
  requestOpen: () => void;
  /** 패널 닫기 버튼/ESC → 패널 닫기 요청. */
  requestClose: () => void;
  /** TodayPage 언마운트 시 열림 상태 초기화(stale 자동재오픈·포커스 끌림 방지). */
  reset: () => void;
}

export const useTodayHistoryStore = create<TodayHistoryState>((set) => ({
  open: false,
  requestOpen: () => set({ open: true }),
  requestClose: () => set({ open: false }),
  reset: () => set({ open: false }),
}));
